import React, { useState } from "react";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import {v4 as uuidv4} from 'uuid';
import * as Constants from '../../Pages/Constants';
import PatientFunctionsGetter from '../../Controller/getSQLPatientFunctions.js';
import DataServiceSQL from "../../DataService/DataServiceSQL";
import InvalidObject from '../Common/InvalidObject.js';
import {FormattedMessage} from 'react-intl';
import DatePicker from 'react-date-picker';
import "../Common/DatePickerStyle.css";
import "../Common/DatePickerCalendar.css";
import DefaultPatient from './PatientDefaultParams.js';
import Utils from '../Common/Utils.js';
import { Switch2, SwitchLabel, SwitchRadio, SwitchSelection } from '../Common/SwitchStyles.js'

const AddPatient = (props) => {
  const [patient, setPatient] = useState({patient_firstname :'', patient_lastname: '', patient_birthdate: new Date(), patient_sex: "female", patient_ins: false, patient_birthplace: '', external_user_mail: '', provider: false});

  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");

  const [template, setTemplate] = useState("0");
  const [profileCreationType, setProfileCreationType] = useState("internal");
  const [waitForAnswerRequest, setWaitForAnswerRequest] = useState(false);
  const [waitForCreationEnding, setWaitForCreationEnding] = useState(false);
  const [refusedCreationRequest, setRefusedCreationRequest] = useState(false);
  const [showImportProviderList, setShowImportProviderList] = useState(false);
  const [showTemplateList, setShowTemplateList] = useState(false);
  const [invalidObject, setInvalidObject] = useState(false);
  const [requestId, setRequestId] = useState("");

  const cancelInvalidObjectPopup = () => {
    setInvalidObject(false);
  }

  const handleInputChange = event => {
    const { name, value } = event.target;
    setPatient({ ...patient, [name]: value });
  };

  const handleCheckboxExternalPatientChange = event => {
    if (profileCreationType === "internal") {
      setProfileCreationType("external");
    }
    else {
      setProfileCreationType("internal");
    }
  };

  const handleCheckboxImportProfile = event => {
    setShowImportProviderList(!showImportProviderList)
  };

  const handleCheckboxTemplate = event => {
    setShowTemplateList(!showTemplateList)
  };

  //Function to determine if creation type is internal or external
  const handleExternalProvider = event => {
    event.preventDefault();
    if(event.target.value === "0"){
      setPatient({ ...patient, patient_ins: false, provider: false });
    }
    else if(event.target.value === "ins"){
      setPatient({ ...patient, patient_ins: true, provider: false });
    }
    else if(event.target.value === "lowenstein"){
      setPatient({ ...patient, patient_ins: false, provider: "lowenstein" });
    }
    else if(event.target.value === "resmed"){
      setPatient({ ...patient, patient_ins: false, provider: "resmed" });
    }
  }

  //Function to handle birthdate value 
  const handleChangeBirthdate = (birthdate) => {
    setPatient({ ...patient, patient_birthdate: new Date(birthdate) });
  };

  //Function to handle birthdate value 
  const handleChangeBirthdateNoDay = (birthdate) => {
    let new_date = new Date(patient.patient_birthdate)
    new_date.setMonth(birthdate.target.value.split('-')[1] - 1)
    new_date.setFullYear(birthdate.target.value.split('-')[0])
    setPatient({ ...patient, patient_birthdate: new_date });
  };

  const handleSwitchChange = (val) => {
    let switch_tab = [{id:"male", defaultMessage:"Male"}, {id:"female",defaultMessage:"Female"}]
    let new_id = switch_tab.find(item => item.defaultMessage === val.props.defaultMessage).id
    setPatient({ ...patient, patient_sex: new_id });
  };

  //Function to generate random UUID number
  const generateUUID = () => {
    return (uuidv4())
  }

  const titleCase = str =>
    str.split(/\s+/).map(w => w[0].toUpperCase() + w.slice(1)).join(' ');

  const ClickableLabel = ({ title, onChange, id }) =>
    <SwitchLabel onClick={() => onChange(title)} className={id}>
      {title}
    </SwitchLabel>;

  const ConcealedRadio = ({ value, selected }) =>
    <SwitchRadio type="radio" name="switch" defaultChecked={selected === value} />;

  const selectionStyle = (liste_sex) => {
    return {
      left: `${liste_sex.indexOf(liste_sex.find(item => item.id === patient.patient_sex)) / 2 * 100}%`,
    };
  };

  const createSwitchSex = () => {
    let liste_sex = [
      {label: <FormattedMessage id="param.SwitchMale" defaultMessage="Male"/>, id:"male"},
      {label: <FormattedMessage id="param.SwitchFemale" defaultMessage="Female"/>, id:"female"},
    ]
    return (
      <Switch2>
        {liste_sex.map(val => {
          return (
            <span>
              <ConcealedRadio value={val.id} selected={patient.patient_sex} />
              <ClickableLabel title={val.label} onChange={handleSwitchChange} />
            </span>
          );
        })}
        <SwitchSelection style={selectionStyle(liste_sex)} />
      </Switch2>
      )
  }

  //Function to create a patient profile from current account
  const createPatient = async () => {

    if (profileCreationType === "external") {
      if (Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("hepadom")) === false) {
      //eslint-disable-next-line
      let checkExp = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');

      //Check if the entry is a mail address with a good format
      if (!checkExp.test(patient.external_user_mail)){
        setmessage(<FormattedMessage id="message.invalidMailFormat" defaultMessage="Invalid mail address format" />);
        setInvalidObject(true);
        return(false)
      }
    }
      else {
        patient.external_user_mail = ""
      }
    }
    else if (patient.external_user_mail === undefined || patient.external_user_mail === null || patient.external_user_mail === "null" || patient.external_user_mail === "") {
      patient.external_user_mail = "NULL"
    }

    let ret;
    setmessage(<FormattedMessage id="patient.message" defaultMessage="Patient creation, please wait..." />);
    
    var data = DefaultPatient.getPatientDefaultParams();

    data.Patient_Data.firstname         = patient.patient_firstname;
    data.Patient_Data.lastname          = patient.patient_lastname;
    data.Patient_Data.birthdate         = patient.patient_birthdate;
    data.Patient_Data.sex               = patient.patient_sex;
    data.Patient_Data.birthplace        = patient.patient_birthplace;
    data.Patient_Data.ins               = patient.patient_ins;
    data.Patient_Data.provider          = patient.provider;
    data.Patient_Data.share_info.owner  = props.accountInformation.email;
    data.Patient_Data.id_patient        = generateUUID();
    data.role                             = props.accountInformation.role;
    data.structure                        = props.accountInformation.FK_structure;
    data.external_user_mail               = patient.external_user_mail;
    data.template                       = template

    //TEMP: SET MONITORING A NO CAR DEFAULT === SMARTPHONE
    data.Patient_Data.monitoring_activation   = "no";

    //Check if all fields are correctly filled
    if((data.Patient_Data.firstname === "")||(data.Patient_Data.birthdate === undefined)){
      setmessage(<FormattedMessage id="patient.create.wrongEntry" defaultMessage="Please precise at least a firstname and a birthdate to create the profile"/>)
      setInvalidObject(true)
    }
    else{
      setWaitForCreationEnding(true);

      if(props.groups !== undefined && props.selected_filter !== undefined)
      {
        let decoded_group = JSON.parse(props.selected_filter);
        var group = props.groups.find(g => {
          return g.id_group === decoded_group.id
        })
        data.Patient_Data.group = group
      }
      if (data.Patient_Data.group === undefined || data.Patient_Data.group.id_group === "nogroup") {
        data.Patient_Data.group = {description: "For patient without group", group_name: "No Group", id_group: "null"}
      }

      // Create
      ret = await PatientFunctionsGetter.create_patient_fhir(data);
      if (!ret){
        setmessage(<FormattedMessage id="message.error.addpatient.createfhir" defaultMessage="Oups, did not work... (err_code addpatient_createfhir)" />);
      }
      setPatient({ ...patient, external_user_mail: undefined });

      setWaitForCreationEnding(false);
      //Creation patient ok and monitoring activated
      if (ret === "OK") {
        props.subscription_info.sub_used += 1
          setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
      }
      //Creation patient ok but monitoring not activated because not enough subscription available
      else if (ret === "sub_error") {
        setmessage(<FormattedMessage id="account.subscriptionErrorExceed" defaultMessage="Warning: your subscription doesn't allow more monitoring" />);
      }
      //Creation patient ko because error with INS research: multiple patient found
      else if (ret === "Multiple results") {
          setmessage(<FormattedMessage id="INS.multiple" defaultMessage="Error : INS research found multiple patients, filling of the patient INS data impossible" />);
      }
      //Creation patient ko, general error
      else if (ret === false) {
        setmessage(<FormattedMessage id="message.error.addpatient" defaultMessage="Oups, did not work... (err_code addpatient)" />);
      }
      //Creation patient ko, error with the INS
      else {
          setmessage(<FormattedMessage id="INS.error" defaultMessage="Error with the INS research" />);
      }
          setsubmitted(true);

    }

  }

  const test_ins_data = () => {
    let ret = true

    if (patient.patient_firstname === undefined || patient.patient_firstname === ""
      || patient.patient_lastname === undefined || patient.patient_lastname === ""
      || patient.patient_birthdate === undefined || patient.patient_birthdate === ""
      || patient.patient_sex === undefined || patient.patient_sex === "")
    {
      ret = false
    }
    else if (!Utils.ins_check_valid_last_names(patient.patient_lastname)) {
      ret = false
    }
    else if (!Utils.ins_check_valid_first_names(patient.patient_firstname)) {
      ret = false
    }
    else if (!Utils.ins_check_valid_dates(patient.patient_birthdate)) {
      ret = false
    }
    else if (!Utils.ins_check_valid_sex(patient.patient_sex)) {
      ret = false
    }
    else if (patient.patient_birthplace !== undefined && patient.patient_birthplace !== "" && !Utils.ins_check_valid_birthPlace(patient.patient_birthplace)) {
      ret = false
    }
    return ret
  }

  const savePatient = async () => {

    if (patient.patient_ins === true && test_ins_data() === false) {
      setmessage(<FormattedMessage id="message.invalidInsParams" defaultMessage="If searching INS data, must have valid first name, last name, birthdate and sex" />);
      setInvalidObject(true);
    }
    else {
    if ((props.accountInformation !== undefined)&&(props.accountInformation.email !== undefined)){
          createPatient();
      } 

    else{
      setmessage(<FormattedMessage id="patient.error2" defaultMessage="Error while loading current account information" />);
      setsubmitted(true);
    }
    }

  };

  const generateSelectTemplate = () => {
    let templates = []
    props.groups.forEach(group => {
      if (group.group_name === "Templates") {
        props.template_list.forEach(profile => {
            templates.push({name : profile.Patient_Data.firstname + ' ' + profile.Patient_Data.lastname, id_patient: profile.Patient_Data.id_patient})
        })
      }
    })
    return (
      <select onChange={(e) => setTemplate(e.target.value)} value={template}>
        <FormattedMessage id="template.notemplate" defaultMessage="No template">
           {(message) => <option key={0} value={0}>{message}</option>}
        </FormattedMessage>
        <FormattedMessage id="template.newtemplate" defaultMessage="New template">
           {(message) => <option key={-1} value={-1}>{message}</option>}
        </FormattedMessage>
        {templates.map(({ name, id_patient }) => (
          <option key={id_patient} value={id_patient}>
            {name}
          </option>
        ))}
      </select>
    )
  }

  const generateOptionsWithCheckbox = (label_id, label_default, input_id, checkboxChange) => {
    return (
        <Row style={{width:"100%", color: "black"}}>
          <Col sm={11} style={{padding: 0, textAlign: "left"}}>
            <label style={{ fontWeight: "bold", fontSize:"1.1em", textAlign: "left" }}>
              <FormattedMessage id={label_id} defaultMessage={label_default} />
            </label>
          </Col>
          <Col sm={1} style={{padding: 0, textAlign: "right"}}>
            <input
              type="checkbox"
              id={input_id}
              onChange={checkboxChange}
              name={input_id}
              style={{width: "100%", border: "1px solid gray"}}
            />
          </Col>
        </Row>
    )
  }

  const addPatientForm = () => {

  return (
                        <div>
                          <div className="form-group" style={{paddingTop:"5%"}}>
                            <label htmlFor="patient firstname">
                              <FormattedMessage id="patient.firstname" defaultMessage="Firstname / IPP" />                                           
                            </label>
                            <br/>
                            <input
                              type="text"
                              id="patient_firstname"
                              required
                              defaultValue={patient.patient_firstname}
                              onChange={handleInputChange}
                              name="patient_firstname"
                              style={{width: "100%", border: "1px solid gray"}} 
                            />
                          </div>
                          <div className="form-group" style={{paddingTop:"5%"}}>
                            <label htmlFor="patient lastname">
                              <FormattedMessage id="patient.lastname" defaultMessage="Lastname" />                                           
                            </label>
                            <br/>
                            <input
                              type="text"
                              id="patient_lastname"
                              required
                              defaultValue={patient.patient_lastname}
                              onChange={handleInputChange}
                              name="patient_lastname"
                              style={{width: "100%", border: "1px solid gray"}} 
                            />
                          </div>
                          <div className="form-group" style={{paddingTop:"5%"}}>
      <label htmlFor="patient birthdate">
                              <FormattedMessage id="patient.birthdate" defaultMessage="Birthdate" />                                           
                            </label>
                            <DatePicker
                              calendarIcon={null}
                              clearIcon={null}
                              onChange={handleChangeBirthdate} 
                              value={patient.patient_birthdate}
                              id="patient_birthdate"
                            />
                          </div>

      <div className="form-group" style={{paddingTop:"5%"}}>
      <label htmlFor="patient birthplace">
            <FormattedMessage id="patient.birthplace" defaultMessage="Birthplace" />
      </label>
      <br/>
      <input
      type="text"
      id="patient_birthplace"
      required
      defaultValue={patient.patient_birthplace}
      onChange={handleInputChange}
      name="patient_birthplace"
      style={{width: "100%", border: "1px solid gray"}}
      />
      </div>

      <div className="form-group" style={{paddingTop:"5%"}}>
      <br/>

        <p>
          {createSwitchSex()}
        </p>
      </div>

        {((props.role === 'admin')||(props.role === 'staff')) ?
          <div className="form-group">
            {generateOptionsWithCheckbox("patient.selectAccountProvider", "Import profile from", "patient_provider", handleCheckboxImportProfile)}
            {showImportProviderList ? 
              <select onChange={handleExternalProvider} defaultValue={"0"}>
                <FormattedMessage id="patient.select.option.noimport" defaultMessage="No import">
                   {(message) => <option key={0} value={0}>{message}</option>}
                </FormattedMessage>
                <FormattedMessage id="patient.select.option.importIns" defaultMessage="INS">
                   {(message) => <option key={"ins"} value={"ins"}>{message}</option>}
                </FormattedMessage>
                <FormattedMessage id="patient.select.option.importLowenstein" defaultMessage="Lowenstein">
                   {(message) => <option key={"lowenstein"} value={"lowenstein"}>{message}</option>}
                </FormattedMessage>
                <FormattedMessage id="patient.select.option.importResmed" defaultMessage="Resmed">
                   {(message) => <option key={"resmed"} value={"resmed"}>{message}</option>}
                </FormattedMessage>
              </select>
              :
              null
            }
          </div>
          :
          null
        }

        {((props.role === 'admin')||(props.role === 'staff')) ?
          <div className="form-group">
            {generateOptionsWithCheckbox("patient.selectExternalAccount", "Patient access", "patient_ins", handleCheckboxExternalPatientChange)}
                            </div>
                            :
                            null
                          }

        {profileCreationType === "internal" ? 
          (
            null
                      )
                      :
                      ( 
          <div className="form-group" style={{}}>
            <Row style={{width:"100%", color: "black"}}>
              <Col style={{padding: 0, width:"100%", textAlign: "left"}}>
                <label htmlFor="patient email" style={{}}>
                <FormattedMessage id="patient.email" defaultMessage="Email" />
                                </label>
              </Col>
              <Col style={{padding: 0, width:"100%", textAlign: "right"}}>
                                <input
                                  type="text"
              id="external_user_mail"
                                  required
              defaultValue={patient.patient_email}
                                  onChange={handleInputChange}
              name="external_user_mail"
                                  style={{width: "100%", border: "1px solid gray"}} 
                                />
              </Col>
            </Row>
                              </div>
          )
        }

      {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("patient_template")) ?
        <div className="form-group" style={{}}>
            {generateOptionsWithCheckbox("patient.template", "Template", "patient_template", handleCheckboxTemplate)}
          {showTemplateList ?
            generateSelectTemplate()
            :
            null
          }
        </div>
        :
        null
      }

      </div>
    )
  }

  const addPatientFormHepadom = () => {
    let converted_date = patient.patient_birthdate.getFullYear() + '-'
    let getMonth = patient.patient_birthdate.getMonth()
    getMonth += 1
    if (getMonth < 10) {
      converted_date = converted_date + '0' + getMonth
    }
    else {
      converted_date = converted_date + getMonth
    }
    return (
      <div>
      <div className="form-group" style={{paddingTop:"5%"}}>
          <label htmlFor="patient firstname">
            <FormattedMessage id="patient.identifier" defaultMessage="Identifier" />                                           
      </label>
      <br/>
      <input
      type="text"
            id="patient_firstname"
      required
            defaultValue={patient.patient_firstname}
      onChange={handleInputChange}
            name="patient_firstname"
      style={{width: "100%", border: "1px solid gray"}}
      />
                            </div>
      <div className="form-group" style={{paddingTop:"5%"}}>
      <label htmlFor="patient birthdate">
      <FormattedMessage id="patient.birthdate" defaultMessage="Birthdate" />
      </label>
      <br/>
          <input type="month" id="patient.birthdate" name="patient.birthdate" value={converted_date} onChange={handleChangeBirthdateNoDay} style={{width:"100%"}}/>
      </div>

          {((props.role === 'admin')||(props.role === 'staff')) ?
            <div className="form-group">
              <br/>
              {generateOptionsWithCheckbox("patient.selectExternalAccount", "Patient access", "patient_ins", handleCheckboxExternalPatientChange)}
            </div>
            :
            null
          }

              {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("patient_template")) ?
          <div className="form-group" style={{}}>
            {generateOptionsWithCheckbox("patient.template", "Template", "patient_template", handleCheckboxTemplate)}
            {showTemplateList ?
              generateSelectTemplate()
              :
              null
            }
                            </div>
      :
      null
              }

      </div>
    )
  }

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {(submitted) ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterAdd} className="btn btn-success">
                  <FormattedMessage id="button.close" defaultMessage="Close" />                        
                </button>
              </center>
            </div>
          ) 
          : 
          (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end">
                    <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                      <FormattedMessage id="patient.add" defaultMessage="Add patient" />
                    </Col>
                  </Row>
                </div>
                <br/>
                {waitForCreationEnding ? 
                  <div>  
                    <h4>{message}</h4>
                    {refusedCreationRequest ?
                      <button onClick={props.cancelPopup} className="btn btn-danger">
                        <FormattedMessage id="button.close" defaultMessage="Close" />
                      </button>
                      :
                      null
                    }
                  </div>
                  :
                  <div>
                    {Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("hepadom")) ?
                      addPatientFormHepadom()
                      :
                      addPatientForm()
                    }
                    {!waitForAnswerRequest ?
                      <div>
                        <br/>                                
                        <button onClick={props.cancelPopup} className="btn btn-danger">
                          <FormattedMessage id="button.cancel" defaultMessage="Cancel" />                                           
                        </button> 
                        <b>&emsp;</b>                               
                        <button onClick={savePatient} className="btn btn-success">
                          <FormattedMessage id="button.submit" defaultMessage="Submit" />                                           
                        </button>
                      </div>
                      :
                      null
                    }
                  </div>
                }
              </center>
            </div>
          )}
          <div>
            {invalidObject ?
              <InvalidObject cancelPopup={cancelInvalidObjectPopup} message={message}/>
              :
              null
            }
          </div>
        </div>
        </div>
    </div>
  );
};

export default withStyles(Constants.styles)(AddPatient);
